import { render, staticRenderFns } from "./_post_slug.vue?vue&type=template&id=96654f86&scoped=true"
import script from "./_post_slug.vue?vue&type=script&lang=js"
export * from "./_post_slug.vue?vue&type=script&lang=js"
import style0 from "./_post_slug.vue?vue&type=style&index=0&id=96654f86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96654f86",
  null
  
)

export default component.exports